import {
    FETCH_USER_SUBSCRIPTIONS,
    FETCH_CONTACT_SUBSCRIPTIONS,
    SET_SUBSCRIPTION
} from '../actions/actionTypes';

const initialState = {
    userSubscriptions:    [],
    contactSubscriptions: [],
    selectedSubscription: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_SUBSCRIPTIONS:
            return {
                ...state,
                userSubscriptions: [...action.payload]
            };
        case FETCH_CONTACT_SUBSCRIPTIONS:
            return {
                ...state,
                contactSubscriptions: [...action.payload]
            };
        case SET_SUBSCRIPTION:
            return {
                ...state,
                selectedSubscription: { ...action.payload }
            };
        default:
            return state;
    }
};
